import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";

@Injectable()
export class UserService {
    /**
     * Get access token
     * @returns {Observable<string>}
     */
    public getAuthUser(): Observable<string> {
        const user: string = <string>localStorage.getItem("user");
        return of(user);
    }

    /**
     * Set refresh token
     * @returns {UserService}
     */
    public setAuthUser(userData: string): UserService {
        localStorage.setItem("user", JSON.stringify(userData));
        return this;
    }
    /**
     * Remove tokens
     */
    public clear() {
        localStorage.removeItem("user");
    }
}
